export const POPULATE = 'LandingZoneMigrationPopulate'

export const SET_LOADED = 'LandingZoneMigrationSetLoaded'

export const SET_STEP = 'LandingZoneMigrationSetStep'
export const SET_MODE = 'LandingZoneMigrationSetMode'
export const SET_IN_PROGRESS = 'LandingZoneMigrationSetInProgress'
export const SET_DISPLAY_FOOTER = 'LandingZoneMigrationSetDisplayFooter'
export const SET_LOGS = 'LandingZoneMigrationSetLogs'
export const SET_INTERLZS = 'LandingZoneMigrationSetInterLZs'
export const SET_DEFAULT_ROUTES = 'LandingZoneMigrationSetDefaultRoutes'

export const MODE_LOG_APP = 'LandingZoneMigrationLogModeApp'
export const MODE_LOG_NSG = 'LandingZoneMigrationLogModeNsg'

export const SET_SELECTED = 'LandingZoneMigrationSetSelected'